import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Observable } from "rxjs";

import {
    BackgroundColor,
    SECONDARY_COLOR,
} from "@hermes/aphrodite/expansion-panel";
import { Packaging } from "@hermes/api-model-packaging";

import {
    ANGULAR_AGEC_NEW_FORMAT_PACKAGING,
    FeatureFlagFacade,
} from "@hermes/states/flipper";

import { AgecService } from "../../services/agec.service";

@Component({
    selector: "h-agec-packagings",
    templateUrl: "./agec-packagings.component.html",
    styleUrls: ["./agec-packagings.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgecPackagingsComponent {
    public agecPackaging$: Observable<Packaging[]> =
        this.agecService.getPackagings();

    public displayNewFormatPackaging$: Observable<boolean | undefined> =
        this.featureFlagFacade.isActivated(ANGULAR_AGEC_NEW_FORMAT_PACKAGING);

    public collapsable: boolean = true;
    public isOpen: boolean = false;
    public secondaryColor: BackgroundColor = SECONDARY_COLOR;

    constructor(
        private agecService: AgecService,
        private featureFlagFacade: FeatureFlagFacade,
    ) {}

    public onCollapsedChange(): void {
        this.isOpen = !this.isOpen;
    }
}
